import {
  Container,
  Group,
  Text,
  Stack,
  Anchor,
  Box,
  Divider,
} from "@mantine/core";
import { IconMail, IconPhone } from "@tabler/icons-react";

// Cross-app links, kept deliberately subtle (bottom legal row, not the main
// Product column) — same VITE_ADMIN_URL/VITE_AUDITOR_URL naming convention
// as docker-compose.yml and the other apps' own crossAppRedirect.ts, though
// landing doesn't depend on that package itself.
const adminPortalUrl =
  import.meta.env.VITE_ADMIN_URL || "http://localhost:5176";
const auditorPortalUrl =
  import.meta.env.VITE_AUDITOR_URL || "http://localhost:5177";

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <Box component="footer" bg="#212529" py={60}>
      <Container size="xl">
        <Stack gap="xl">
          {/* Main Footer Content */}
          <Group justify="space-between" align="flex-start" wrap="wrap">
            {/* Brand */}
            <Stack gap="sm" maw={300}>
              <Text
                size="xl"
                fw={700}
                style={{
                  background:
                    "linear-gradient(135deg, #4a8c71 0%, #5aba9d 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                LivingSyncs
              </Text>
              <Text size="xs" c="dimmed" fs="italic" mb="xs">
                Empowering Health, Enriching Lives!
              </Text>
              <Text size="sm" c="dimmed">
                Complete management system for group homes and assisted living
                facilities with enterprise-grade security and compliance.
              </Text>
            </Stack>

            {/* Product Links */}
            <Stack gap="xs">
              <Text size="sm" fw={600} c="white" mb="xs">
                Product
              </Text>
              {/* Root-relative so they also work from /terms and /privacy */}
              <Anchor href="/#features" size="sm" c="dimmed" underline="never">
                Features
              </Anchor>
              <Anchor href="/#pricing" size="sm" c="dimmed" underline="never">
                Pricing
              </Anchor>
              {/* Only links that resolve. Demo, Documentation and the whole
                  Company column (About Us, Careers, Blog, Contact) were
                  href="#" placeholders — dead ends are a poor look on a page
                  selling compliance, and "Contact" duplicated Get in Touch. */}
            </Stack>

            {/* Contact */}
            <Stack gap="xs">
              <Text size="sm" fw={600} c="white" mb="xs">
                Get in Touch
              </Text>
              <Group gap="xs">
                <IconMail size={16} color="#868e96" />
                <Anchor
                  href="mailto:hello@livingsyncs.com"
                  size="sm"
                  c="dimmed"
                  underline="never"
                >
                  hello@livingsyncs.com
                </Anchor>
              </Group>
              <Group gap="xs">
                <IconPhone size={16} color="#868e96" />
                <Anchor
                  href="tel:+18329913017"
                  size="sm"
                  c="dimmed"
                  underline="never"
                >
                  (832) 991-3017
                </Anchor>
              </Group>
            </Stack>
          </Group>

          <Divider color="#343a40" />

          {/* Bottom Footer */}
          <Group justify="space-between" wrap="wrap">
            <Text size="sm" c="dimmed">
              © {currentYear} LivingSyncs. All rights reserved.
            </Text>
            <Group gap="xl">
              <Anchor href="/privacy" size="sm" c="dimmed" underline="never">
                Privacy Policy
              </Anchor>
              <Anchor href="/terms" size="sm" c="dimmed" underline="never">
                Terms of Service
              </Anchor>
              <Anchor
                href="/privacy#hipaa"
                size="sm"
                c="dimmed"
                underline="never"
              >
                HIPAA Compliance
              </Anchor>
              <Anchor
                href={adminPortalUrl}
                size="xs"
                c="dimmed"
                underline="never"
                opacity={0.6}
              >
                Admin Portal
              </Anchor>
              <Anchor
                href={auditorPortalUrl}
                size="xs"
                c="dimmed"
                underline="never"
                opacity={0.6}
              >
                Auditor Portal
              </Anchor>
            </Group>
          </Group>
        </Stack>
      </Container>
    </Box>
  );
}
